import { useEffect } from 'react';
import { useCookieConsent } from '../providers/CookieConsentProvider';

const ANALYTICS_SCRIPT_ID = 'munifocus-analytics';
const ANALYTICS_SRC = import.meta.env.VITE_ANALYTICS_SRC;
const ANALYTICS_DOMAIN = import.meta.env.VITE_ANALYTICS_DOMAIN;

/**
 * Consent-gated analytics loader. Injects a privacy-friendly (Plausible-style)
 * script tag only while the visitor has granted the `analytics` cookie
 * category, and removes it the moment consent is withdrawn. It is a complete
 * no-op when `VITE_ANALYTICS_SRC` is unset, so dev / preview builds stay clean.
 *
 * Renders nothing — all effect is on the document <head>.
 */
export function Analytics() {
  const { isAllowed } = useCookieConsent();
  const allowed = isAllowed('analytics');

  useEffect(() => {
    if (!ANALYTICS_SRC) return;
    const existing = document.getElementById(ANALYTICS_SCRIPT_ID);

    if (!allowed) {
      existing?.remove();
      return;
    }
    if (existing) return;

    const script = document.createElement('script');
    script.id = ANALYTICS_SCRIPT_ID;
    script.src = ANALYTICS_SRC;
    script.defer = true;
    if (ANALYTICS_DOMAIN) script.setAttribute('data-domain', ANALYTICS_DOMAIN);
    document.head.appendChild(script);
  }, [allowed]);

  return null;
}
